/* eslint-disable max-statements */
import { CanvasTexture, Sprite, SpriteMaterial } from 'three';

const CANVAS_SIZE = 256;

export type BadgeSpriteParams = {
	/** The glyph or short text drawn in the middle — `!`, a count, a `+` */
	label: string;
	/** Disc colour */
	fill: string;
	/** Scene units (inches) across the badge */
	size: number;
	renderOrder: number;
};

/**
 * A round badge on an offscreen canvas, wrapped in a camera-facing sprite. Depth testing is off
 * so it stays readable through the kitchen; the raycaster still has to be told it is an overlay.
 */
export const createBadgeSprite = (params: BadgeSpriteParams): Sprite => {
	const { label, fill, size, renderOrder } = params;
	const canvas = document.createElement('canvas');
	canvas.width = CANVAS_SIZE;
	canvas.height = CANVAS_SIZE;
	const ctx = canvas.getContext('2d');

	const center = CANVAS_SIZE / 2;
	const radius = center - 10;

	// a dark halo keeps the badge readable against a pale countertop or a bright sky
	ctx.beginPath();
	ctx.arc(center, center, radius + 5, 0, Math.PI * 2);
	ctx.fillStyle = 'rgba(0, 0, 0, 0.35)';
	ctx.fill();

	ctx.beginPath();
	ctx.arc(center, center, radius, 0, Math.PI * 2);
	ctx.fillStyle = fill;
	ctx.fill();
	ctx.lineWidth = 10;
	ctx.strokeStyle = '#ffffff';
	ctx.stroke();

	ctx.fillStyle = '#ffffff';
	ctx.font = `bold ${label.length > 1 ? 120 : 150}px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif`;
	ctx.textAlign = 'center';
	ctx.textBaseline = 'middle';
	ctx.fillText(label, center, center + 6);

	const texture = new CanvasTexture(canvas);
	const material = new SpriteMaterial({ map: texture, depthTest: false, depthWrite: false, toneMapped: false });
	const sprite = new Sprite(material);
	sprite.scale.set(size, size, 1);
	sprite.renderOrder = renderOrder;

	return sprite;
};
